import ApiService from './api.service';

export default {
  getBusinessDetails(businessId) {
    return ApiService.get(`business/${businessId}`);
  },
};



// WEBPACK FOOTER //
// ./src/services/businessDetails.service.js